const DUMMY_PROJECTS=[
    {
        projectTitle:'Project Argus',
        description: 'Python, Java, C#, .NET, MSSQL, Nginx, TensorFlow, Roboflow, Supervision, Yolo, OpenCV, Docker, GCP, Google Colab',
        sourceLink:'https://github.com/FYP-Event-tracking',
        lastUpdated:'Jul 30 2024'
    },
    {
        projectTitle:'Code Cracker',
        description: 'GO, Consul, TypeScript, Docker, Firebase authentication, React, PostgreSQL',
        sourceLink:'https://github.com/ManujaDewmina/Code-Cracker',
        lastUpdated:'Jul 30 2024'
    },
    {
        projectTitle:'Job Ranker - Backend',
        description: 'LSTM sentiment analysis, Python, MySQL, Kaggle, Tensorflow, NLTK, Docker, GCP, REST API',
        sourceLink:'https://github.com/ManujaDewmina/Job-Ranker-Backend',
        lastUpdated:'Dec 10 2022'
    },
    {
        projectTitle:'Job Ranker - Frontend',
        description: 'Dart, Flutter, Firebase Auth, Data visualization, REST API',
        sourceLink:'https://github.com/ManujaDewmina/Job-Ranker-Frontend',
        lastUpdated:'Dec 10 2023'
    },
    {
        projectTitle:'E-Classroom and Student Tracker',
        description: 'JAVA, XML, Jitsi Meet SDK, Firebase Realtime Database, Firebase Auth, Firebase Storage, Firestore Dtabase',
        sourceLink:'https://github.com/ManujaDewmina/E-Classroom-and-Student-Tracker',
        lastUpdated:'Sep 27 2022'
    },
    {
        projectTitle:'Travelers Guide and Assistant',
        description: 'JAVA, XML, Google Maps API, OpenWeather API, News API, Google Developers ML Kit, Firebase',
        sourceLink:'https://github.com/ManujaDewmina/Travellers-Guide-and-Assistant',
        lastUpdated:'Oct 30 2022'
    },
    {
        projectTitle:'Ballroom',
        description: 'React, Ballerina, TypeScript, Docker, WSO2 Asgardeo, WSO2 Choreo, RabbitMQ, MySQL',
        sourceLink:'https://github.com/Ballroom-Platform',
        lastUpdated:'Sep 09 2023'
    },
    {
        projectTitle:'Unity Talk',
        description: 'Dart, Flutter, Firebase, Google Vision API, Google Translation API, Google ML Kit',
        sourceLink:'https://github.com/ManujaDewmina/Unity-Talk',
        lastUpdated:'Feb 03 2024'
    },
    {
        projectTitle:'Sudoku Solver with OpenCV',
        description: 'C++, OpenCV, Python, Dancing Links Algorithm, Backtracking Algorithm, Image Processing',
        sourceLink:'https://github.com/ManujaDewmina/Sudoku-solver-with-OpenCV',
        lastUpdated:'Jan 07 2024'
    },
    {
        projectTitle:'Mereter',
        description: 'HTML, CSS, Bootstrap, JavaScript, Flutter, Dart, Firebase',
        sourceLink:'https://github.com/ManujaDewmina/Mereter',
        lastUpdated:'May 18 2022'
    },
];
const ProjectsData={DUMMY_PROJECTS};
export default ProjectsData;